import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=cf5b5334&scoped=true&"
import script from "./Branding.vue?vue&type=script&lang=ts&"
export * from "./Branding.vue?vue&type=script&lang=ts&"
import style0 from "./Branding.vue?vue&type=style&index=0&id=cf5b5334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5b5334",
  null
  
)

export default component.exports